import { supabase } from "./supabase.js";
import { askStreaming } from "./ndjson.js";
import { extractDocument, canRead, extensionOf } from "./docText.js";

/* Asking the server to read a document.
 *
 * The file is turned into text here, in the browser, and only the text
 * travels. PDFs are the exception and go across whole, because reading one
 * properly needs the page layout. Either way the Anthropic key stays on
 * Netlify's servers, where it was put.
 */

export { canRead, extensionOf };

const ENDPOINT = "/.netlify/functions/read-document";

export async function readDocument({ contractId, period, doc = {}, file, fileName, onProgress }) {
  const name = fileName || file?.name || "";
  if (!canRead(name)) {
    throw new Error("That file type cannot be read. Word, PowerPoint, PDF, Excel, CSV and plain text can.");
  }

  const { data: session } = await supabase.auth.getSession();
  const token = session?.session?.access_token;
  if (!token) throw new Error("Your session has expired. Sign in again.");

  const extracted = await extractDocument(file, name);

  const found = await askStreaming(ENDPOINT, {
    token,
    onProgress,
    what: "The reading",
    body: {
      contractId,
      period,
      text: extracted.text,
      pdf: extracted.pdf,
      docKind: doc.kind || "",
      docName: doc.title || name,
      docDate: doc.doc_date || "",
    },
  });

  return { summary: found.summary || "", entries: found.entries || [] };
}
